<app-shell-admin-warning-banner></app-shell-admin-warning-banner>
<ng-container *ngIf="viewModel$ | async as viewModel">
	<dx-data-grid
		[dataSource]="viewModel.dataSource"
		[showBorders]="true"
		(onEditorPreparing)="onEditorPreparing($event)"
	>
		<dxo-sorting mode="multiple"></dxo-sorting>
		<dxo-paging [enabled]="false"></dxo-paging>
		<dxo-filter-row [visible]="true"></dxo-filter-row>
		<dxo-editing [allowAdding]="true" [allowUpdating]="true" [allowDeleting]="true"></dxo-editing>
		<dxo-search-panel [visible]="true"></dxo-search-panel>

		<dxi-column
			dataField="companyId"
			caption="Company"
		>
			<dxo-lookup
				[dataSource]="viewModel.companyDatasource"
				valueExpr="id"
				[displayExpr]="companyIdDisplayExpr"
			>
			</dxo-lookup>
		</dxi-column>
		<dxi-column
			dataField="userId"
			caption="User"
		>
			<dxo-lookup
				[dataSource]="viewModel.userDatasource"
				valueExpr="id"
				[displayExpr]="userIdDisplayExpr"
			>
			</dxo-lookup>
		</dxi-column>
		<dxi-column
			dataField="isOwner"
			caption="Is owner"
			dataType="boolean"
			[width]="80"
		>
		</dxi-column>
	</dx-data-grid>
</ng-container>
